import { render, staticRenderFns } from "./switcher.vue?vue&type=template&id=1536f7d6&scoped=true&lang=pug&"
import script from "./switcher.vue?vue&type=script&lang=js&"
export * from "./switcher.vue?vue&type=script&lang=js&"
import style0 from "./switcher.vue?vue&type=style&index=0&id=1536f7d6&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1536f7d6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('1536f7d6', component.options)
    } else {
      api.reload('1536f7d6', component.options)
    }
    module.hot.accept("./switcher.vue?vue&type=template&id=1536f7d6&scoped=true&lang=pug&", function () {
      api.rerender('1536f7d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form_element/boolean/switcher.vue"
export default component.exports